(() => {
  if (window.titanHeaderSearchBound) return;
  window.titanHeaderSearchBound = true;
  const ROOT = '[data-header-search]';
  const roots = () => document.querySelectorAll(ROOT);
  function open(root) {
    document.dispatchEvent(new CustomEvent('theme:close-navigation'));
    root.classList.add('is-open');
    const trigger = root.querySelector('[data-search-trigger]');
    if (root.dataset.searchStyle !== 'field') trigger.setAttribute('aria-expanded', 'true');
    root.querySelector('input[type="search"]').focus({ preventScroll: true });
  }
  function close(root) {
    root.classList.remove('is-open');
    if (root.dataset.searchStyle !== 'field') root.querySelector('[data-search-trigger]').setAttribute('aria-expanded', 'false');
    root.querySelector('predictive-search')?.dismiss?.();
    const results = root.querySelector('.header__search-results');
    if (results) results.style.display = 'none';
  }
  function init() {
    roots().forEach(root => {
      if (root.dataset.searchStyle !== 'field') root.classList.add('is-collapsible');
    });
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || event.defaultPrevented) return;
    roots().forEach(root => { if (!root.contains(event.target)) close(root); });
    const trigger = event.target.closest('[data-search-trigger]');
    const root = trigger?.closest(ROOT);
    if (root?.classList.contains('is-collapsible') && !root.classList.contains('is-open')) { event.preventDefault(); open(root); }
  });
  document.addEventListener('submit', event => {
    const root = event.target.closest(ROOT);
    if (root && !root.querySelector('input[type="search"]').value.trim()) { event.preventDefault(); open(root); }
  });
  document.addEventListener('keydown', event => {
    if (!(event.target instanceof Element) || event.key !== 'Escape') return;
    const root = event.target.closest(ROOT);
    if (!root) return;
    event.preventDefault(); event.stopPropagation();
    close(root);
    root.querySelector('[data-search-trigger]').focus({ preventScroll: true });
  });
  document.addEventListener('focusout', event => {
    if (!(event.target instanceof Element)) return;
    const root = event.target.closest(ROOT);
    if (root && !root.contains(event.relatedTarget)) close(root);
  });
  document.addEventListener('theme:close-navigation', () => roots().forEach(close));
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => roots().forEach(close));
  matchMedia('(max-width: 767px)').addEventListener('change', () => roots().forEach(close));
  window.addEventListener('pageshow', () => { init(); roots().forEach(close); });
  init();
})();
